// ProductCardSm.jsx
import React, { useState } from 'react'
import { Image, Button } from 'react-bootstrap'
import 'swiper/css'

import RecommendIcon from '../icons/RecommendIcon'
import PromotionIcon from '../icons/PromotionIcon'
import FavoriteIcon from '../icons/FavoriteIcon'
import CartIcon from '../icons/CartIcon'
import CheckIcon from '../icons/CheckIcon'

import FeedbackForm from './FeedbackForm'
import CartNotification from './CartNotification'

import styles from './../style/ProductCardSm.module.scss'

const ProductCardSm = ({
  id,
  title,
  image,
  article,
  manufacturer,
  price,
  old_price,
  inStock,
  recomended = false,
  promotion = false,
  short = false,
  changeFavorite,
  favorite,
  cart,
  addTocart,
  user_profile_type = 'individual',
  link = '#',
  fullWidth = false,
  certificate = false
}) => {

  const isFavorite = !short ? favorite.includes(id) : false
  const isInCart = !short ? cart.some(item => item.product === id) : false

  const [show_feedback, set_feedback] = useState(false)
  const [show_cart, set_cart] = useState(false)
  const [quantity, setQuantity] = useState(100)

  const add = () => {
    const count = user_profile_type == 'legal' ? quantity : 1
    addTocart( { product: id, count: count }, () => {
      set_cart( true )
    })
  }

  const handleQuantityChange = (e) => {
    const value = parseInt(e.target.value)
    if (!isNaN(value) && value > 0) {
      setQuantity(value)
    }
  }

  const incrementQuantity = () => {
    setQuantity(prev => prev + 100)
  }

  const decrementQuantity = () => {
    if (quantity > 1) {
      setQuantity( prev => ( prev - 100 > 0 ? prev - 100 : 0 ) )
    }
  }

  const priceFormat = (price, delimiter, fraction) => {
    if(price == 0 || price == '') return 0
    fraction = [0,1,2].indexOf(fraction) !== -1 ? fraction : 2
    delimiter = delimiter || ' '
    price = (price = parseFloat(price)) && isFinite(price) && price.toFixed(fraction) || false
    if (price === false) throw new TypeError('Price should be a valid integer.')
    var reverseString = function(string) {
        return string.split('').reverse().join('')
    }
    return reverseString(reverseString(price).replace(/(\d{3})/g, '$&' + delimiter))
  }

  return (
    <div className={short ? styles.productCardShort : ( fullWidth ? styles.productCardFW : styles.productCard )}>
      <div className={styles.productHeader}>
        {!short &&
          <div onClick={() => changeFavorite(id)} className={styles.favoriteButton}>
            <FavoriteIcon isFavorite={isFavorite} />
          </div>
        }
        <div className={styles.recommendIcon}>
          {recomended && <RecommendIcon />}
          {promotion && <PromotionIcon />}
          {certificate &&
            <div className={styles.certificateTooltip}>
              <CheckIcon />
              <span className={styles.tooltipText}>Цена товара - по сумме вашего сертификата</span>
            </div>
          }
        </div>
      </div>
      <div className={styles.productContent}>
        <div style={{ position: 'relative' }}>
          <div className={styles.productImage}>
            <Image alt={title} src={image} width={140} height={140} />
          </div>
          <div className={styles.productArticle}>Арт. {article != '' ? article : title}</div>
          <a href={link} className={styles.productTitle + ' stretched-link'}>{title}</a>
          <div className={styles.productManufacturer}>{manufacturer}</div>
        </div>
        {!short &&
          <>
            <div className={styles.divider}></div>
            <div className={styles.productFooter}>
              <div className={styles.productPrice}>
                {old_price != `` && <span className='text-decoration-line-through'>{old_price}</span>}
                {priceFormat( price )} ₽ / шт
              </div>
              <div className={styles.productStock}>
                {inStock ? (
                  <span className={styles.inStock}>В наличии</span>
                ) : (
                  <span className={styles.outOfStock}>Под заказ</span>
                )}
              </div>
            </div>
            {user_profile_type === 'legal' &&
              <div className={styles.quantitySelector}>
                <button onClick={decrementQuantity} className={styles.quantityButton}>
                  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12.5" cy="12.5" r="12.5" fill="white"/>
                    <path d="M18 12.75L7.5 12.75" stroke="#1E9FF6" strokeLinecap="round"/>
                  </svg>
                </button>
                <input 
                  type="text" 
                  value={quantity} 
                  onChange={handleQuantityChange}
                  className={styles.quantityInput}
                />
                <button onClick={incrementQuantity} className={styles.quantityButton}>
                  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12.5" cy="12.5" r="12.5" fill="white"/>
                    <path d="M12.75 7.5V18" stroke="#1E9FF6" strokeLinecap="round"/>
                    <path d="M18 12.75L7.5 12.75" stroke="#1E9FF6" strokeLinecap="round"/>
                  </svg>
                </button>
              </div>
            }
          </>
        }
      </div>
      {!short &&
        <div className={styles.productActions}>
          <Button onClick={() => set_feedback( true )} variant="primary" className={styles.oneClickButton}>
            Купить в 1 клик
          </Button>
          <Button onClick={() => add()} variant="primary" className={`${styles.cartButton} ${isInCart ? styles.inCart : ''}`}>
            <span>{isInCart ? 'В корзине' : 'В корзину'}</span>
            <CartIcon />
          </Button>
        </div>
      }
      <FeedbackForm
        title={`Оформите заказ в 1 клик`}
        text={
          <>
            Заполните форму и мы свяжемся с вами,<br />чтобы согласовать детали покупки
          </>
        }
        btn={`Отправить`}
        data={[
          {
            name: `Товар`,
            value: title
          },
          {
            name: `Цена`,
            value: price
          },
          {
            name: `Количество`,
            value: user_profile_type === 'legal' ? quantity : 1
          }
        ]}
        show={show_feedback}
        handleClose={() => set_feedback(false)}
      />
      <CartNotification 
        show={show_cart} 
        onHide={() => set_cart(false)}
        product={{
          id: id,
          article: article,
          title: title,
          manufacturer: manufacturer,
          price: price,
          image: image
        }}
        addTocart={addTocart}
        def_count={user_profile_type === 'legal' ? quantity : 1}
      />
    </div>
  )
}

export default ProductCardSm